var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsMerge = function SvgIconsMerge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.364 2a2.364 2.364 0 0 1 .57 4.658 4.907 4.907 0 0 0 4.41 4.41 2.362 2.362 0 0 1 4.656.568 2.364 2.364 0 0 1-4.669.526 5.993 5.993 0 0 1-4.372-2.46l-.05-.07v3.823c0 .28-.21.51-.482.541L4.364 14c-.28 0-.51-.21-.542-.482l-.004-.063V6.664A2.365 2.365 0 0 1 4.364 2zm7.272 8.364a1.273 1.273 0 1 0 0 2.545 1.273 1.273 0 0 0 0-2.545zM4.364 3.09a1.273 1.273 0 1 0 0 2.545 1.273 1.273 0 0 0 0-2.545z"
  })));
};
export default SvgIconsMerge;